<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="red-line">
        <ng-container *ngIf="editMode">
          <td colspan="1">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('appendix')"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
          </td>
        </ng-container>
        <td [attr.colspan]="(editMode?29:33)"><widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'appendix.labelAppendix' | rdTranslate}}</widget-value></td>
      </tr>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_appendix_topics'" [editMode]="editMode" [rows]="rows" [leftColspan]="18" [rightColspan]="15" [data]="widgetData" [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$" [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$" [moveCurrentRowDown]="moveCurrentRowDown$"
                              (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
</div>
